function pushClassPdpShareDataLayer({
  event,
  destination,
  share_presentation,
  share_source,
  share_url,
  content_title
}) {
  try {
    window.dataLayer ||= []
    window.dataLayer.push({
      event,
      destination,
      share_source,
      content_title,
      share_url,
      share_presentation
    })
  } catch (e) {
    /* non-fatal */
  }
}

function writeClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text)
  }
  return new Promise((resolve, reject) => {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.style.position = 'fixed'
    ta.style.left = '-9999px'
    document.body.appendChild(ta)
    ta.select()
    try {
      document.execCommand('copy')
      resolve()
    } catch (err) {
      reject(err)
    } finally {
      document.body.removeChild(ta)
    }
  })
}

function appendUtm(url, source) {
  try {
    const u = new URL(url, window.location.href)
    u.searchParams.set('utm_source', source)
    u.searchParams.set('utm_medium', 'social_share')
    u.searchParams.set('utm_campaign', 'content_page')
    return u.toString()
  } catch (e) {
    return url
  }
}

function shareLine(title, kind) {
  if (kind === 'series') {
    return `Check out the program "${title}" on ALO Wellness Club`
  }
  return `Check out "${title}" on ALO Wellness Club`
}

export const handleShareClick = async ({
  url,
  title,
  kind,
  emailSubject,
  share_presentation = '',
  share_source = '',
  action
}) => {
  const line = shareLine(title, kind)
  const event = `${kind}_social_share`
  pushClassPdpShareDataLayer({
    event,
    destination: action,
    share_presentation,
    share_source,
    share_url: url,
    content_title: title
  })
  if (action === 'facebook') {
    const u = appendUtm(url, 'facebook')
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}`,
      'facebook-share-dialog',
      'width=626,height=436,noopener,noreferrer'
    )
    return
  }
  if (action === 'message') {
    const uSms = appendUtm(url, 'sms')
    window.location.href = `sms:?&body=${encodeURIComponent(`${line} ${uSms}`)}`
    return
  }
  if (action === 'email') {
    const uMail = appendUtm(url, 'email')
    window.location.href = `mailto:?subject=${encodeURIComponent(
      emailSubject
    )}&body=${encodeURIComponent(`${line} ${uMail}`)}`
    return
  }
  if (action === 'copy_link') {
    const uCopy = appendUtm(url, 'copy_link')
    try {
      await writeClipboard(`${line} ${uCopy}`)
      return 'copy_link'
    } catch {}
  }
  return null
}
